module.exports = __webpack_public_path__ + "img/pr-14.66b38274.png";